module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-800italic.be24e015.svg";